import React from "react";
import { IoIosArrowDown } from "react-icons/io";
import { Helmet } from "react-helmet";  
 import './admin.css';
 import Adminmenu from "./admin_menu";
export default function Admin() {
    return (
        <div className="container_roots">
            <Adminmenu/>
            </div>
    )
};